<template>
  <div class="content"></div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'articles',
  components: {
  },
  data() {
    return {
    };
  },
  methods: {
    ...mapActions([
      'chTitle', 'chCGB',
    ]),
  },
  mounted() {
    this.chCGB(false);
    this.chTitle('Home');
    this.$http.get(this.$config.uri('article/pages')).then((r) => {
      if (r.data.status !== 200) return;
      window.location.href = `${process.env.BASE_URL}article/${r.data.data[0].slug}`;
    });
  },
};
</script>


<style scoped lang="scss">
  .content{
    background-image: url(../assets/loading.svg);
    background-size: 40px auto;
    background-position: center;
    background-repeat: no-repeat;
  }
</style>
